export const createAddButton = ({ title, link }) => {
  return {
    title: title,
    link: link,
  };
};
